module.exports = __webpack_public_path__ + "img/m-bg3.17ecea4f.jpg";